import styled from 'astroturf/react';
import Svg from 'src/components/Svg';

const CommentsSectionWrapper = styled('div')`
  padding: 20px;
  display: flex;
  justify-content: space-between;
  position: relative;  
  font-size: var(--ph-required-indicate);
  &.disabled *{
    pointer-events: none;
  }

  &.isOpen {
    cursor: pointer;
  }

  [class*='editableText'] {
    padding-left: 0px !important;
  }
`;

const CommentStatus = styled('p')`
  background: var(--cyan-green);
  font-size: var(--ph-required-indicate);
  height: 20px;
  padding: 5px 15px;
  margin-left: 10px;
  margin-top: 2px;
  line-height: 1;
  border-radius: 2px;

  &.isOpen {
    background: var(--ph-red-500);
    color: var(--white);
  }
`;

const CommentStatusWrapper = styled('div')`
  display: inline-flex;
  font-family: var(--ph-font-family-source-sans-pro-regular);
  position: absolute;
  top: 22px;
  right: 28px;
  cursor: pointer;
  height: 22px;
  &.disabled *{
    pointer-events: none;
  }
`;

const OutcomesButtonWrapper = styled('div')`
  overflow-x: auto;
  overflow-y: hidden;
  border-bottom: 0.5px solid var(--ph-light-gray-25);
  padding: 20px;
`;

const ResultVerificationSection = styled('div')`
  position: sticky;
  vertical-align: top;
  display: inline-block;
  top: -25px;
  width: 30%;
  min-width: 300px;
  min-height: 250px;
  background-color: var(--white);
  transition: right 0.3s, min-width 0.3s, padding 0.3s;
  z-index: 9998;

  &.reducedWidth {
    width: 30%;
  }

  &.hidden {
    right: -100%;
    visibility: hidden;
  }

  @media (max-width: 1300px) {
    &.isSidebarExpanded {
      min-width: 430px;
      width: 430px;
      padding: 20px;
    }
  }
`;

const ResultVerificationSectionContent = styled('div')`
  overflow-y: auto;
  max-height: 100vh;
  overflow-x: hidden;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  ::-webkit-scrollbar {
    width: 10px;
  }

  &.noCommentsAvailable {
    border-bottom: 0.5px solid var(--ph-light-gray-25);
  }

  div[class*='switcher'] {
    padding: 20px;
    button[aria-checked='false'] {
      border: 1px solid var(--light-white);
      background-color: var(--light-white);
    }
    span{ 
      color: var(--dark-blue);
      font-size: var(--ph-heading-size) !important;
      font-family: var(--ph-font-family-lato-bold);
    }
  }
`;
const ResultVerificationSectionButtonContent = styled('div')`
    display: block;  
    font-size: 11px !important;
    font-family: var(--ph-font-family-lato-bold);
    max-width: 340px;
    width: 100%;
    white-space: nowrap;
    &.disabled *{
      pointer-events: none;
    }

    span[class*='fa-xmark']:before {
      font: normal normal normal var(--ph-heading-size) / 1 FontAwesome;
      content: '\f00d';      
    }
    button[class*='accurateBtn'] {  
      flex-basis: 100%;  
      background: transparent;
      color: var(--ph-light-gray);  
      border-color: var(--ph-light-gray);
      margin-right: 15px;
      span{
        font-size: var(--ph-text-md) !important;
        font-family: var(--ph-font-family-lato-bold);
      }
      span:before {
        font: normal normal normal var(--ph-heading-size) / 1 FontAwesome;
      }
      &:not(.accurateBtn.on){    
      }
    }
    button[class*='accurateBtn on']{      
      background: var(--cyan-green);
      border-color: var(--cyan-green);
      color: var(--dark-blue);
    }
    button[class*='accurateBtn on']:hover { 
      background: var(--cyan-green); 
    } 
    button[class*='inAccurate_Btn'] {
      margin-right: 15px;
      background: transparent;
      color: var(--ph-light-gray);  
      border-color: var(--ph-light-gray); 
      flex-basis: 100%;  
      span{
        font-size: var(--ph-text-md) !important;
        font-family: var(--ph-font-family-lato-bold);
      }
    }  
    button[class*='inAccurate_Btn on'] {
      background: var(--dark-notification-red);
      border-color: var(--dark-notification-red);
      color: var(--white);
    } 
    button[class*='inAccurate_Btn on']:hover { 
      background: var(--dark-notification-red); 
    }
    button[class*='otherOutcome_Btn'] {
      margin-right: 15px;
      background: transparent;
      color: var(--ph-light-gray);  
      border-color: var(--ph-light-gray); 
      flex-basis: 100%;  
      span{
        font-size: var(--ph-text-md) !important;
        font-family: var(--ph-font-family-lato-bold);
      }
    }
    button[class*='otherOutcome_Btn on'] {
      background: var(--ph-gray-500);
      border-color: var(--ph-gray-500);
      color: var(--white);
    }
    button[class*='otherOutcome_Btn on']:hover { 
      background: var(--ph-gray-500); 
    }
`;
const QuestionRowWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  margin-left: -10px;
  padding: 10px 20px;
  border-bottom: 0.5px solid var(--ph-light-gray-25);  
  &.disabled *{
    pointer-events: none;
  }

  div[class*='isRectifiedQuestion'] not(.filepond--file-info) span{ 
    font-size: 13px !important;
    font-family: var(--ph-font-family-lato-bold);
    color: var(--dark-blue);
  }
  label[class*='monthOnly']{
    min-width: 50px;
  }
`;

const QuestionTextSection = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 0.5px solid var(--ph-light-gray-25);
`;

const QuestionText = styled('div')`  
    font-size: var(--ph-heading-size) !important;
    font-family: var(--ph-font-family-lato-bold);
    letter-spacing: normal;
    color: var(--dark-blue);
`;

const PageNavigation = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const PaginationText = styled('div')`  
  font-size: var(--ph-heading-size) !important;
  font-family: var(--ph-font-family-lato-regular);
  letter-spacing: normal;
  color: var(--dark-blue);
  margin: 0 10px;
`;

const IconL = styled(Svg)`
  width: 8px;
  top: 1px;
`;

const IconR = styled(Svg)`
  width: 8px;
  top: 1px;
`;

const Arrow = styled('div')`
  color: var(--ph-gray-500);
  transition: var(--ph-button-transition);
  font-family: var(--ph-font-family-franklin-medium-regular);
  font-size: var(--ph-text-sm);
  border-radius: var(--ph-border-radius-sm);
  display: inline-flex;
  appearance: none;
  align-items: center;
  justify-content: center;
  user-select: none;
  touch-action: manipulation;
  text-transform: none;
  position: relative;
  white-space: nowrap;
  vertical-align: middle;
  line-height: 1.2;
  outline: none;
  padding-left: 12px;
  padding-right: 12px;
  height: 32px;
  min-width: 32px;
  border: 0;
  cursor: pointer;
  border-radius: 50%;
  background-color: var(--light-white);
  &.disabled{
    pointer-events: none;
    background-color: transparent;
    opacity: .3;
  }

  &:first-child {
    margin-right: 5px;
  }

  &.selected {
    color: var(--black);
    opacity: 1;
    text-decoration: none;
    background-color: var(--ph-gray-50);
  }

  &:hover {
    background-color: var(--cyan-green-30);
    color: var(--cyan-green);
    border-radius: 50%;
  }
  &.left:hover g[id*='pagination-arrowLeft'] {
      stroke: var(--dark-green-100);
   }
  &.right:hover g[id*='pagination-arrowRight'] {
      stroke: var(--dark-green-100);
   }  

  &:active {
    background-color: var(--cyan-green-30);
    color: var(--cyan-green);
    border-radius: 50%;
  }

  &:focus {
    box-shadow: var(--ph-box-shadow-focus);
  }

`;

const AttachmentsSection  = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 50px;
  padding: 20px;
  position: sticky;
  bottom: 0;
  min-height: 190px;
  border-top: 0.5px solid var(--ph-light-gray-25);
  background-color: var(--white);
`;

const AttachmentsTitle = styled('h3')`
  font-family: var(--ph-font-family-lato-bold);
  font-size: var(--ph-heading-size);
  color: var(--dark-blue);
  padding-top: 7px;
  padding-bottom: 10px;
`;

const NoQuestionOpenCommentSection = styled('p')`
  color: var(--dark-blue);
  font-size: var(--ph-text-sm) !important;
  font-family: var(--ph-font-family-lato-bold);
  padding: 20px 20px 10px 20px;
`;

const OpenCommentQuestionsCount = styled('span')`
  color: var(--white);
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: var(--ph-red-500);
  font-size: var(--ph-text-xs);
  display: inline-block;
  text-align: center;
  line-height: 17px;
  margin-left: -10px;
  margin-top: 23px;
`;

const OpenQuestionContentWrapper = styled('div')`
  display: inline-flex;
`;

const ScrollableContent = styled('div')`
  min-height: 135px;
`;

const StatusHeading = styled('p')`
  font-size: var(--ph-required-indicate);
  font-family: var(--ph-font-family-lato-semibold);
  margin-top: 5px;
  color: var(--dark-blue);
`;

export default {
  CommentsSectionWrapper,
  CommentStatus,
  CommentStatusWrapper,
  OpenCommentQuestionsCount,
  OpenQuestionContentWrapper,
  OutcomesButtonWrapper,
  ResultVerificationSection,
  ResultVerificationSectionContent,
  ResultVerificationSectionButtonContent,
  QuestionRowWrapper,
  QuestionTextSection,
  QuestionText,
  PageNavigation,
  Arrow,    
  IconL,
  IconR,
  PaginationText,
  AttachmentsSection,
  AttachmentsTitle,
  NoQuestionOpenCommentSection,
  ScrollableContent,
  StatusHeading
}